import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp6-amelia-bones-found-murdered-at-her-home",
  name: `The Daily Prophet\n'Amelia Bones Found Murdered at her Home'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Amelia Bones Found Murdered at her Home'",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
